<div class="not-found-container">
    <div class="container col-5">
        <svg viewBox="0 0 300 100" width="100%" height="auto" xmlns="http://www.w3.org/2000/svg">
            <!-- Líneas del pentagrama -->
            <g stroke="#c5d5dc" stroke-width="1">
                <line x1="0" y1="20" x2="300" y2="20" />
                <line x1="0" y1="30" x2="300" y2="30" />
                <line x1="0" y1="40" x2="300" y2="40" />
                <line x1="0" y1="50" x2="300" y2="50" />
                <line x1="0" y1="60" x2="300" y2="60" />
            </g>

            <!-- Nota blanca (izquierda) -->
            <g transform="translate(40, 35)">
                <ellipse cx="0" cy="0" rx="10" ry="10" fill="white" stroke="#6e91a2" stroke-width="2" />
            </g>

            <!-- Silencio de blanca (centro) -->
            <g transform="translate(140, 40)">
                <rect x="-12" y="0" width="24" height="6" fill="#6e91a2" />
            </g>

            <!-- Nota blanca (derecha) -->
            <g transform="translate(240, 35)">
                <ellipse cx="0" cy="0" rx="10" ry="10" fill="white" stroke="#6e91a2" stroke-width="2" />
            </g>

        </svg>
    </div>

    <h1>404</h1>
    <p>La página que buscas no está sonando bien... <a routerLink="/">vuelve a comenzar</a></p>
    
</div>